import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTable"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import cmsStore from "stores/cmsStore.js"
import "style/CheckoutPage.scss"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import queryString from "qs"
import CartExport from "components/Cart/CartExport"
import Price from "components/Price/Price"
import CostCentres from "../../../../components/CostCentres/CostCentres";

@observer
export default class CheckoutPage extends Component {
  
  state = {
    products: getProducts(),
    frachtkosten: true,
    productsTemp: []
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    shop.cart.hydrate()
    track.checkout( { step: 1, products: shop.cart.products } )
    shop.cart.update()
  }
  
  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }
  
  updateCart = () => {
    let products = getProducts()
    products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    this.setState({productsTemp: shop.cart.products})
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products, frachtkosten } = this.state
    const { loading } = shop.cart
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    //console.log("frachtkosten",frachtkosten)
    // MINDERMENGENZUSCHLAG UNTER 50 EUR
    const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE
    
    const showPenaltyNotice = shop.cart.sum < MIN_ORDER
    
    return (
      <div className=" ">
        <HeaderCheckout activeStep={0} isRequest={isRequest} referer={referer}/>
        
        {/*<section className="container pb4">
          <CostCentres />
        </section>*/}
  
        <section className="container">
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
          <div className="cf pt3 pb3">
            <div className="fr">
              <CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
            </div>
          </div>
          {/*showPenaltyNotice && <Message>
            <div>{translate( "MIN_ORDER_VALUE_NOTICE", { value: `${shop.config.MIN_ORDER_PENALTY_VALUE}` } )}</div>
      </Message>*/}
      						{shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
						<div className="cf pb2">
							<Message negative className="">
								<div className="total ">
									<div className="ph3">
										<Icon name="info" />{translate( "minimum order value not reached" )}
										<span className="pull-right">
                    						<Price>{shop.config.MIN_ORDER_VALUE}</Price>
								     </span>
									</div>
								</div>
								
							</Message>
						</div>
						}
          {frachtkosten == true && <Message onClick={() => this.setState( {frachtkosten: false} )} visible={frachtkosten == true} hidden={frachtkosten == false} >
            <div>&#9654; Frachtkosten</div>
          </Message>}
          {frachtkosten == false && <Message onClick={() => this.setState( {frachtkosten: true} )} visible={frachtkosten == false} hidden={frachtkosten == true} >
            <div>&#9660; Frachtkosten</div>
            <Table>
            <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{translate( "Informationen" )}</Table.HeaderCell>
                    <Table.HeaderCell>{translate( "Frachtkosten" )}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
              <Table.Body>
              <Table.Row>
                  <Table.Cell>Wir sind stets bemüht, den kostengünstigsten Versandweg zu wählen. <br/>
                  Zusätzliche Kartonverpackung ist möglich und wird entsprechend der Kosten, in Rechnung gestellt. <br/>
                  Es gelten unsere allgemeinen Verkaufs-und Lieferbedingungen.<br/>
                  Bei den uns genannten UVPs handelt es sich um unverbindliche Preisempfehlungen.<br/>
                  Alle Zentimeter-und Gramm Angaben sind cira-Angaben.<br/><br/>
                  Wir liefern ab einem Auftragswert 500,00 € frei Haus innerhalb der BRD<br/>
                  (keine Insellieferung). Etwaige Frachtkosten für Insellieferungen werden separat in Rechnung gestellt!
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{'Folgende Frachtkosten werden bei Bestellungen unter der frei Haus Grenze berechnet:'}</Table.Cell>
                  <Table.Cell>  <Table.Row><Table.Cell>{'Pro Matratze/Lattenrost	30,50 €'} <br/></Table.Cell></Table.Row>
                  <Table.Row><Table.Cell>{'Bei Bettwaren pro Postpaket	14 €'}<br/></Table.Cell></Table.Row>
                  <Table.Row><Table.Cell>{'Matratzen ab 160/200 	49,50 €'}</Table.Cell></Table.Row></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{'Bei Lieferungen an Endverbraucher (nur Ausnahme und auf Anfrage)'}<br/> {'werden grundsätzlich folgende Frachtkosten berechnet:'}</Table.Cell>
                  <Table.Cell>  <Table.Row><Table.Cell>{'Pro Matratze/Lattenrost	41,50 €'} <br/></Table.Cell></Table.Row>
                  <Table.Row><Table.Cell>{'bei Bettwaren pro Postpaket	16,00 €'}<br/></Table.Cell></Table.Row>
                  <Table.Row><Table.Cell>{'Matratzen ab 160/200 	55,00 €'}</Table.Cell></Table.Row></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Message>}
          {cmsStore.pluginData.export && <div className="pv3">
            <CartExport/>
          </div>}
        </section>
        
        <section className="pa2 mb4 ">
          <div className="container">
            <div className="flex flex-row justify-end">
              
              <Link className={"mr3"} to={referer}>
                <Button>
                  <i className="icon-angle-left"/>
                  {translate( "Zurück" )}
                </Button>
              </Link>
              
             <Link to={{
                pathname: `${this.props.location.pathname}delivery`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "WeiterShoppingCart" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>
              
             
            </div>
          
          </div>
        </section>
      
      
      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product)



// WEBPACK FOOTER //
// ./src/theme/mags/pages/checkout/CheckoutPageCoupon.js